'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _dec3, _class, _class2, _temp2;
// import { Link } from 'react-router';
// import config from '../../config';
// remove this one

// import {isLoaded, load as loadWidgets} from 'redux/modules/widgets';


// import 'katex/dist/katex.min.css';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactI18next = require('react-i18next');

var _home = require('redux/modules/home');

var homeActions = _interopRequireWildcard(_home);

var _lesson = require('redux/modules/lesson');

var lessonActions = _interopRequireWildcard(_lesson);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _reactBootstrap = require('react-bootstrap');

var _components = require('components');

var _reduxAsyncConnect = require('redux-async-connect');

var _reactRedux = require('react-redux');

var _reactKatex = require('react-katex');

var _reactHtmlParser = require('react-html-parser');

var _reactHtmlParser2 = _interopRequireDefault(_reactHtmlParser);

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _language = require('redux/modules/language');

var languageActions = _interopRequireWildcard(_language);

var _i18next = require('i18next');

var _i18next2 = _interopRequireDefault(_i18next);

var _ArticleList = require('./ArticleList');

var _ArticleList2 = _interopRequireDefault(_ArticleList);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isLoaded = homeActions.isLoaded,
    loadContents = homeActions.loadContents;
var loadLessonsWithFirstContent = lessonActions.loadLessonsWithFirstContent;
var loadRecentWords = languageActions.loadRecentWords,
    loadRecentWords3 = languageActions.loadRecentWords3,
    loadRecentSentences = languageActions.loadRecentSentences;
var Home = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: true,
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState,
        language = _ref.params.language;

    // console.log("asyncConnect");
    var promises = [];
    promises.push(dispatch(loadLessonsWithFirstContent()));
    promises.push(dispatch(loadRecentWords3(1, language)));

    promises.push(dispatch(loadRecentSentences(1)));

    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    directions: state.home.data,
    lessons_first_content: state.lesson.lessons_first_content,
    recentWords: state.language.data,
    sentences: state.language.sentences,
    user: state.auth.user
  };
}, (0, _extends3.default)({}, homeActions, lessonActions, languageActions)), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Home, _Component);

  function Home() {
    var _ref2;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Home);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = Home.__proto__ || (0, _getPrototypeOf2.default)(Home)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      selectedOption: ''
      // componentDidMount() {
      //   // require('katex/dist/katex.min.css');
      //   // this.forceUpdate();
      //   const _SortableTree = require('react-sortable-tree').default;
      //
      // }

    }, _this.handleChange = function (selectedOption) {
      _this.setState({ selectedOption: selectedOption });
      // selectedOption can be null when the `x` (close) button is clicked
      if (selectedOption) {
        console.log('Selected: ' + selectedOption.label);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Home, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._ismounted = true;
      // var LineChart = require("react-chartjs").Line;
      // var Highcharts = require('react-highcharts');
      // let chart = this.refs.chart.getChart();
      // chart.series[0].addPoint({x: 10, y: 12});
      this.forceUpdate();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._ismounted = false;
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      //do stuff here
    }
  }, {
    key: 'pushTranslation',
    value: function pushTranslation(word, lang) {
      var language = this.props.params.language === undefined ? 'en' : this.props.params.language;
      return '/' + language + '/translate/' + encodeURIComponent(word) + '/' + lang;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./Home.scss');
      var selectedOption = this.state.selectedOption;
      var _props = this.props,
          t = _props.t,
          directions = _props.directions,
          lessons_first_content = _props.lessons_first_content,
          recentWords = _props.recentWords,
          sentences = _props.sentences,
          user = _props.user;


      var initialData = [{ id: '1', name: 'N1', parent: null }, { id: '2', name: 'N2', parent: null }, { id: '3', name: 'N3', parent: 2 }, { id: '4', name: 'N4', parent: 3 }];

      // const getCurrentLng = () => i18n.language || window.localStorage.i18nextLng || '';

      // console.log('current langauge');
      // console.log(i18n);
      // console.log(window.localStorage.i18nextLng);
      var language = this.props.params.language === undefined ? 'en' : this.props.params.language;
      // if not user then redirect to /vi 
      if (language === 'en' && !this.props.user) {
        // this.props.history.push(`/vi`);
        window.location.href = '/';
      }
      return _react2.default.createElement(
        'div',
        { className: styles.home },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Home' }),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement('p', null),
          _react2.default.createElement(
            _reactBootstrap.Grid,
            null,
            _react2.default.createElement(
              _reactBootstrap.Row,
              { className: 'show-grid' },
              _react2.default.createElement(
                _reactBootstrap.Col,
                { sm: 8, md: 8 },
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(_components.SearchView, { onSubmit: function onSubmit(data) {
                      data.language = data.language === undefined ? 'en' : data.language;

                      _this2.props.history.push('/' + language + '/translate/' + encodeURIComponent(data.q) + '/' + data.language);
                    } })
                ),
                _react2.default.createElement('br', null),
                _config2.default.is_for_personal_purpose && _react2.default.createElement(
                  _reactBootstrap.Panel,
                  null,
                  _react2.default.createElement(
                    'div',
                    null,
                    'ADMIN page (easy backup features)'
                  ),
                  _react2.default.createElement(
                    _reactBootstrap.Button,
                    { onClick: function onClick(e) {
                        _this2.props.history.push('/admin');
                      } },
                    'Go to admin page'
                  )
                ),
                _config2.default.is_for_personal_purpose && _react2.default.createElement(
                  _reactBootstrap.Panel,
                  null,
                  _react2.default.createElement(
                    _reactBootstrap.Col,
                    { sm: 3, md: 3 },
                    _react2.default.createElement(
                      _reactBootstrap.Button,
                      { href: '/en', bsStyle: 'success', onClick: function onClick(e) {
                          // e.preventDefault();
                          // this.props.history.push(`/en`);
                        } },
                      'English'
                    ),
                    _react2.default.createElement('p', null)
                  ),
                  _react2.default.createElement(
                    _reactBootstrap.Col,
                    { sm: 3, md: 3 },
                    _react2.default.createElement(
                      _reactBootstrap.Button,
                      { href: '/vi', bsStyle: 'success', onClick: function onClick(e) {
                          // e.preventDefault();
                          // this.props.history.push(`/vi`);
                          // i18n.changeLanguage('vi');
                        } },
                      'Ti\u1EBFng Vi\u1EC7t'
                    ),
                    _react2.default.createElement('p', null)
                  )
                ),
                _config2.default.is_for_personal_purpose && _react2.default.createElement(
                  _reactBootstrap.Panel,
                  null,
                  _react2.default.createElement(
                    _reactBootstrap.Col,
                    { sm: 3, md: 3 },
                    _react2.default.createElement(
                      _reactBootstrap.Button,
                      { bsStyle: 'success', onClick: function onClick() {
                          _this2.props.history.push('/course/20');
                        } },
                      '\x1BTi\u1EBFng Ph\xE1p'
                    ),
                    _react2.default.createElement('p', null)
                  ),
                  _react2.default.createElement(
                    _reactBootstrap.Col,
                    { sm: 3, md: 3 },
                    _react2.default.createElement(
                      _reactBootstrap.Button,
                      { bsStyle: 'success', onClick: function onClick() {} },
                      'Ti\u1EBFng \u0110\u1EE9c'
                    ),
                    _react2.default.createElement('p', null)
                  ),
                  _react2.default.createElement(
                    _reactBootstrap.Col,
                    { sm: 3, md: 3 },
                    _react2.default.createElement(
                      _reactBootstrap.Button,
                      { bsStyle: 'success', onClick: function onClick() {} },
                      'Ti\u1EBFng T\xE2y Ban Nha'
                    ),
                    _react2.default.createElement('p', null)
                  ),
                  _react2.default.createElement(
                    _reactBootstrap.Col,
                    { sm: 3, md: 3 },
                    _react2.default.createElement(
                      _reactBootstrap.Button,
                      { bsStyle: 'success', onClick: function onClick() {} },
                      'Ti\u1EBFng Anh'
                    ),
                    _react2.default.createElement('p', null)
                  )
                ),
                _config2.default.is_for_personal_purpose && _react2.default.createElement(
                  _reactBootstrap.Panel,
                  null,
                  _react2.default.createElement(
                    _reactBootstrap.Col,
                    { sm: 3, md: 3 },
                    _react2.default.createElement(
                      _reactBootstrap.Button,
                      { bsStyle: 'success', onClick: function onClick() {} },
                      'L\u1EADp Tr\xECnh'
                    )
                  ),
                  _react2.default.createElement(
                    _reactBootstrap.Col,
                    { sm: 3, md: 3 },
                    _react2.default.createElement(
                      _reactBootstrap.Button,
                      { bsStyle: 'success', onClick: function onClick() {} },
                      'C\u1EA5u Tr\xFAc d\u1EEF li\u1EC7u v\xE0 Gi\u1EA3i Thu\u1EADt'
                    ),
                    _react2.default.createElement('p', null)
                  )
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  language === 'vi' && _react2.default.createElement(
                    _reactBootstrap.Panel,
                    null,
                    _react2.default.createElement(
                      'h4',
                      null,
                      'B\xE0i h\u1ECDc'
                    ),

                    // use ArticleList
                    // transform lessons_first_content to array with item is {title: "article"}
                    //convert .name to .title
                    lessons_first_content !== undefined && _react2.default.createElement(_ArticleList2.default, { articles: lessons_first_content })
                  )
                ),
                language === 'en' && _react2.default.createElement(
                  _reactBootstrap.Panel,
                  null,
                  _react2.default.createElement(
                    'h4',
                    null,
                    '\x1BSentences'
                  ),
                  sentences !== undefined && sentences.map(function (item, i) {
                    return _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement(
                          'span',
                          null,
                          _react2.default.createElement(
                            'b',
                            null,
                            item.sentence,
                            ' (',
                            item.lang,
                            ')'
                          )
                        ),
                        ' ',
                        _react2.default.createElement('span', null),
                        ' ',
                        _react2.default.createElement(
                          _reactBootstrap.Button,
                          { href: _this2.pushTranslation(item.sentence, item.lang), bsStyle: 'link', onClick: function onClick(e) {
                              e.preventDefault();
                              _this2.props.history.push(_this2.pushTranslation(item.sentence, item.lang));
                            } },
                          'Xem...'
                        ),
                        _config2.default.is_for_personal_purpose && "Analyze"
                      )
                    );
                  }),
                  _react2.default.createElement(
                    _reactBootstrap.Button,
                    { href: '/' + language + '/sentences/2', onClick: function onClick(e) {
                        e.preventDefault();
                        _this2.props.history.push('/' + language + '/sentences/2');
                      } },
                    t('content.see_more')
                  )
                )
              ),
              console.log(user),
              user !== null && _react2.default.createElement(
                _reactBootstrap.Col,
                { sm: 3, md: 3 },
                _react2.default.createElement(
                  _reactBootstrap.Panel,
                  null,
                  _react2.default.createElement(
                    'h4',
                    null,
                    t('content.new_words')
                  ),
                  recentWords !== undefined && recentWords.map(function (item, i) {
                    return _react2.default.createElement(
                      'div',
                      null,
                      (language === 'vi' && item.definition || language === 'en') && _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement(
                          'span',
                          null,
                          _react2.default.createElement(
                            'b',
                            null,
                            item.word,
                            ' (',
                            item.lang,
                            ')'
                          )
                        ),
                        ' ',
                        _react2.default.createElement(
                          'span',
                          null,
                          item.definition && _react2.default.createElement(
                            'span',
                            null,
                            ' ',
                            item.definition.map(function (data) {
                              var shortDefinition = data.definition + ' ' + (data.more_definition !== undefined ? data.more_definition : '');
                              var definition = shortDefinition.trim() !== '' ? shortDefinition.trim() : data.long_definition;
                              return _react2.default.createElement(
                                'span',
                                null,
                                ' ',
                                definition.substring(0, 40),
                                ' '
                              );
                            }),
                            ' '
                          ),
                          !item.definition && _react2.default.createElement(
                            'span',
                            null,
                            'No definitions'
                          )
                        ),
                        ' ',
                        _react2.default.createElement(
                          _reactBootstrap.Button,
                          { href: _this2.pushTranslation(item.word, item.lang), bsStyle: 'link', onClick: function onClick(e) {
                              e.preventDefault();
                              _this2.props.history.push(_this2.pushTranslation(item.word, item.lang));
                            } },
                          'Xem...'
                        ),
                        _config2.default.is_for_personal_purpose && _react2.default.createElement(
                          _reactBootstrap.Button,
                          { href: '/newKnowledgeWithAShortSumary/' + item.word + '/' + item.lang, bsStyle: 'link', onClick: function onClick(e) {
                              e.preventDefault();
                              _this2.props.history.push('/newKnowledgeWithAShortSumary/' + item.word + '/' + item.lang);
                            } },
                          _config2.default.is_for_personal_purpose && "Create Content"
                        )
                      )
                    );
                  }),
                  _react2.default.createElement(
                    _reactBootstrap.Button,
                    { href: '/' + language + '/knowledge/2', onClick: function onClick(e) {
                        e.preventDefault();
                        _this2.props.history.push('/' + language + '/knowledge/2');
                      } },
                    t('content.see_more')
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Home;
}(_react.Component), _class2.propTypes = {
  t: _react.PropTypes.func,
  directions: _react.PropTypes.array
}, _temp2)) || _class) || _class) || _class);
exports.default = Home;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/Home.js
// module id = 1527
// module chunks = 0